<template> 
   
     <router-view></router-view>
   
</template> 
<script>
   
    export default {
        name:'caiwu',
        data () {
            return {
             
            }
        },
       

        computed: {
          
            
        },
        methods: {
               
           
            
        },
      
        mounted: function(){
            var that = this;
          
        }
    }
</script>  
<style scoped>
    
</style>
     